import { supabaseClient } from '../net/supabase-client.js?v=20260801-token-hash-1';

export async function getActiveWorldRaid() {
  const { data, error } = await supabaseClient.rpc('get_active_world_raid');
  if (error) throw error;
  return data;
}

export async function claimWorldRaidRewards(raidId, requestId = crypto.randomUUID()) {
  const { data, error } = await supabaseClient.rpc('claim_raid_rewards', {
    p_raid_id: String(raidId || ''),
    p_request_id: requestId,
  });
  if (error) throw error;
  return data;
}
